<template>
	<div class="yhdb">
        <main>
            <span>起止日期： </span>
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <span style="margin-left:20px" >车牌：</span>
            <el-input v-model="chepai" placeholder="车牌" style="display:inline-block" clearable></el-input>

            <span>状态： </span>
            <el-select v-model="status" placeholder="请选择" clearable>
                <el-option label="待核销" value="0"></el-option>
                <el-option label="已核销" value="1"></el-option>
            </el-select>

            <span>公司： </span>
            <el-select v-model="org" placeholder="请选择" clearable>
                <el-option label="义乌本部" value="义乌本部"></el-option>
                <el-option label="华农家禽" value="华农家禽"></el-option>
                <el-option label="生猪采购" value="生猪采购"></el-option>
                <el-option label="肉制品" value="肉制品"></el-option>
            </el-select>


            <el-button type="primary" style="margin-left:20px" @click="search()">搜索</el-button>
            <el-button type="success" @click="importStudentExcel()">导入</el-button>
        </main>

        <!-- 点击导入后弹出框 -->
        <el-dialog title="油耗数据导入" :visible.sync="importDialogVisible" width="45%">
            <input ref="file" type="file" accept=".xlsx,.xls,.csv" style="display: none;" @change="uploadFile">
            <el-button type="primary" icon="el-icon-upload" @click="clickFile">选择文件</el-button>
        </el-dialog>

        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">
                <el-table-column
                    width="130"
                    prop="chuanhao"
                    label="设备串号">
                </el-table-column>

                <el-table-column
                    width="150"
                    prop="time"
                    label="加注时间">
                </el-table-column>

                <el-table-column
                    prop="price"
                    label="加注金额">
                </el-table-column>

                <el-table-column
                    prop="weight"
                    label="加注体积">
                </el-table-column>

                <el-table-column
                    prop="type"
                    label="加注模式">
                </el-table-column>

                <el-table-column
                    prop="number"
                    label="加注序号">
                </el-table-column>

                <el-table-column
                    prop="kahao"
                    label="卡号">
                </el-table-column>

                <el-table-column
                    prop="kaid"
                    label="卡ID">
                </el-table-column>

                <el-table-column
                    prop="q_price"
                    label="消费前">
                </el-table-column>

                <el-table-column
                    prop="h_price"
                    label="消费后">
                </el-table-column>

                <el-table-column
                    prop="kname"
                    label="车牌">
                </el-table-column>

                <el-table-column
                    prop="org"
                    label="所属单位">
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status==0">待核销</p>
                        <p style="color:#67C23A" v-if="scope.row.status==1">核销成功</p>
                    </template>
                </el-table-column>
                    <el-table-column label="核销" width="150">
                    <template slot-scope="scope">
                            <el-button type="text" @click="caoZuo(scope.row)">核销</el-button>
                            <el-button type="text" style="color:red" @click="del(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="shenpiren"
                    label="核销人">
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </el-card>

        <el-dialog title="油耗核销" :visible.sync="show" width="80%" top="8vh" :before-close="handleClose">
            <p style="margin-top: -20px;color:red;font-weight: 600;font-size: 16px;">
                <span >公司：{{ row.org }}</span>
                <span style="margin-left: 20px;">车牌：{{ row.kname }} </span>
                <span style="margin-left: 20px;">加注体积：{{row.weight}}</span>
                <span style="margin-left: 20px;">加注时间：{{ row.time }}</span>
            </p>

            <el-card style="border: solid #ccc 1px">
                <el-table
                    :data="tableData2"
                    stripe
                    border
                    height="60vh"
                    style="width: 200%">

                    <el-table-column
                        prop="chepai"
                        label="车牌">
                    </el-table-column>

                    <el-table-column
                        prop="chepai_1"
                        label="车辆类型">
                    </el-table-column>

                    <el-table-column
                        prop="chepai_3"
                        label="使用公司">
                    </el-table-column>

                    <el-table-column
                        prop="gongsi2"
                        label="加油油罐">
                    </el-table-column>

                    <el-table-column
                        prop="time"
                        label="加油时间">
                    </el-table-column>

                    <el-table-column
                        prop="fangshi"
                        label="加油方式">
                    </el-table-column>

                    <el-table-column
                        prop="name"
                        label="驾驶员">
                    </el-table-column>

                    <el-table-column
                        prop="shengshu"
                        label="加油升数">
                    </el-table-column>

                    <el-table-column
                        prop="shengshu2"
                        label="核销升数">
                    </el-table-column>

                    <el-table-column
                        prop="money"
                        label="加油金额">
                    </el-table-column>

                    <el-table-column
                        prop="mess"
                        label="备注">
                    </el-table-column>

                    <el-table-column label="审核状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status==0">待审核</p>
                            <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                            <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                        </template>
                    </el-table-column>

                    <el-table-column label="核销状态">
                        <template slot-scope="scope">
                            <p style="color:gray" v-if="!scope.row.shengshu2">待核销</p>
                            <p v-else style="color:#F56C6C">已核销</p>
                        </template>
                    </el-table-column>

                    <el-table-column label="核销">
                        <template slot-scope="scope">
                            <p style="color:#409EFF" @click="sure(scope.row.id)" >确定</p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="shenpiren"
                        label="审核人">
                    </el-table-column>

                </el-table>

                <el-pagination
                    style="margin:20px 0"
                    background
                    @current-change="handleCurrentChange2"
                    :current-page="current_page2"
                    :page-size="per_page2"
                    layout="prev, pager, next"
                    :total="total2">
                </el-pagination>

            </el-card>
        </el-dialog>


    </div>
</template>

<script>
    import { url,url2 } from '../router/api';

	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                importDialogVisible: false,
                show: false,
                tableData: [],
                tableData2: [],
                time:[],
                chepai:'',
                status:'',
                org:'',

                total2: 1,
                per_page2: 50,
                current_page2: 1,

                row:'',
            }
        },
        mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)
            this.searchDb()
            this.getList()
        },
		methods: {
            importStudentExcel() {
                this.importDialogVisible = true;
            },
            clickFile() {
                this.$refs.file.dispatchEvent(new MouseEvent('click'))
            },
            // 上传文件
            async uploadFile() {
                const file = this.$refs.file.files
                var extName = file[0].name.substring(file[0].name.lastIndexOf('.')).toLowerCase()
                if (extName === '.csv') {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData = new FormData()
                    formData.append('file', file[0])
                    this.axios.post(url+'complaint/upload_yhdb',(formData),{
                        headers: {  'Content-Type': 'multipart/form-data;' }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.loading.close();
                            this.searchDb()
                        }  else {
                            this.loading.close();
                        }
                    }).catch(err=> {
                        this.loading.close();
                        console.log(err);
                    });

                } else {
                    this.$message.error('数据导入失败，请选择正确的csv模板文件')
                }
                this.importDialogVisible = false;
            },

            searchDb() {
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00'
                    time2 = this.time[1] + ' 23:59'
                }
                this.axios.get(url + 'complaint/searchYhdb', {
                    params:{
                        chepai:this.chepai,
                        time1:time1,
                        time2:time2,
                        status:this.status,
                        org:this.org,
                        page:this.current_page,
                        per_page:this.per_page,
                    }
                }).then(res=> {
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                }).catch(err=> {
                    console.log(err);
                });
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.searchDb();
            },

            handleCurrentChange2(val) {
                this.current_page = val;
                this.getList();
            },

            getList() {
                var chepai = ''
                if(this.row) {
                    if(this.row.kname) {
                        chepai = this.row.kname
                    }
                }
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url2+'youkaSearch', {
                    params:{
                        page:this.current_page2,
                        per_page:this.per_page2,
                        bumen:'',
                        chepai:chepai,
                        name:'',
                        address:'',
                        gongsi:'',
                        crate_time1:time1,
                        crate_time2:time2,
                        status:'',
                        status2:'',
                        fangshi:'',
                        xz_status:'',
                    }
                }).then(res=> {
                    this.tableData2 = res.data.data.data
                    this.total2 = res.data.data.total
                }).catch(err=> {
                    console.log(err);
                });
            },

            caoZuo(row) {
                this.show = true
                this.row = row
                this.getList()
            },

            handleClose(done) {
                this.row = ''
                done();
            },

            del(id) {
                console.log(id)
                this.$confirm('是否确定删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url + 'complaint/delYhdb', {
                        params:{
                            id:id,
                        }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.searchDb();
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type:'error'
                            });
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },

            sure(id) {
                this.$confirm('是否确定核销?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url + 'complaint/sureYhdb', {
                        params:{
                            id:this.row.id,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.cladminYh(id)
                            this.show = false
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type:'error'
                            });
                            this.show = false
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },

            cladminYh(id) {
                this.axios.get(url+'complaint/hexiaoDb', {
                    params:{
                        id:id,
                        shengshu2: this.row.weight
                    }
                }).then(res=> {
                    if(res.data.code==1) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.searchDb();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type:'error'
                        });
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            search() {
                this.current_page = 1
                this.searchDb()
            },
        }
    }
</script>
<style scoped="scoped" lang='less'>
    .yhdb {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }

    .yhdb .el-input {
        width:140px;
        margin-right: 20px;
    }

    .yhdb .el-select {
        width:140px;
        margin-right: 20px;
    }

    .yhdb main {
        margin-bottom: 20px;
    }

    .yhdb .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }

</style>



